import { motion } from "framer-motion";

export const Tabela = () => {
  return (
    <section>
      <div className="container mx-auto px-4 max-w-7xl">
        <div className="flex flex-col-reverse lg:flex-row gap-12 lg:items-stretch justify-between">
          <motion.div
            className="w-full lg:w-1/2 h-full overflow-x-auto"
            initial={{ opacity: 0, x: -100 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.8 }}
          >
            <table className="min-w-full border-collapse rounded-xl overflow-hidden shadow">
              <thead>
                <tr className="bg-[#40A835] text-white text-left">
                  <th className="px-6 py-3 font-bold">Espécie</th>
                  <th className="px-6 py-3 font-bold">Diâmetro</th>
                </tr>
              </thead>
              <tbody className="text-sm">
                {[
                  ['Agapornis', '4,5'],
                  ['Periquito Australiano', '4,0', true],
                  ['Grande Alexandre', '8,5'],
                  ['Arara Vermelha', '15,0', true],
                  ['Canário da Terra', '2,8'],
                  ['Canário Belga', '3,0', true],
                  ['Coleiro', '2,2'],
                  ['Azulão', '2,8', true],
                  ['Trinca Ferro', '3,5'],
                  ['Curió', '2,6', true],
                  ['Tarim', '2,5'],
                ].map(([especie, diametro, destaque], idx) => {
                  const bg = idx % 2 === 0 ? 'bg-white' : 'bg-green-50';
                  const textColor = destaque ? 'text-green-600 font-medium' : 'text-gray-800';

                  return (
                    <tr key={`${especie}-${idx}`} className={bg}>
                      <td className={`px-6 py-3 ${textColor}`}>{especie}</td>
                      <td className={`px-6 py-3 ${textColor}`}>{diametro}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </motion.div>

          {/* Cards - direita */}
          <motion.div
            className="w-full lg:w-1/2 flex flex-col gap-8"
            initial={{ opacity: 0, x: 100 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.8, delay: 0.3 }}
          >
            <div>
              <h2 className="text-2xl md:text-3xl font-semibold text-gray-900">
                Outros <span className="font-bold">diâmetros</span>
              </h2>
              <p className="text-left text-2xl font-semibold text-gray-500">
                Encontre rapidamente o diâmetro ideal da anilha para sua ave:
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 font-nunito">
              {[
                { nome: 'Aço Inox - polida ou foleada a ouro 24k', img: '/img/aco.png' },
                { nome: 'Aluminío Polidas', img: '/img/polidas.png' },
                { nome: 'Aluminío Colorida Fechada', img: '/img/fechado.png' },
                { nome: 'Aluminío Colorida Aberta', img: '/img/aberto.png' },
              ].map((item) => (
                <div
                  key={item.nome}
                  className="flex flex-col bg-white p-5 rounded-xl shadow text-center hover:shadow-lg transition-shadow duration-300 h-full"
                >
                  <div className="flex-1 flex flex-col items-center justify-start">
                    <img
                      src={item.img}
                      alt={item.nome}
                      className="w-48 h-30 object-contain mb-4"
                    />
                  </div>
                  <h4 className="text-sm font-medium text-gray-800 mt-auto font-nunito">{item.nome}</h4>
                </div>
              ))}
            </div>
          </motion.div>

        </div>
      </div>
    </section>
  );
};
